import React from 'react';
import webapi from '../../../api/webapi';
import '../../css/bootstrap-rtl.min.css';
//import Parsiglogopng from '../../images/logo.png'
import ParsiglogoFooterpng from '../../images/logoFooter.png'
import Parsiguparrowpng from '../../images/up-arrow.png'

import Parsigpazhouheshgahpng from '../../images/02.png'
import jpeg2 from '../../images/01.png'
import Parsigashajpeg from '../../images/03.png'

class Footer extends React.Component {
    state = {VisitData: ''}
    // constructor(props, context) {
    //     super(props, context);
    // }

    async componentDidMount () {
        this.getVisit();

        var Lang = 'fa';

        if (this.props.Lang!=null)
        {
            Lang = this.props.Lang;
        }else{
            Lang = 'fa';
        }
        this.setState({Lang: Lang });

        if (Lang!=null)
        {
            const pageList = await webapi.get('pages/datapages/9/'+Lang);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/9/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }
        // const script1 = document.createElement("script");
    
        // script1.src = "http://webshomar.com/rx/?counter/stat/90276/3c637aa1059b5e60cad33ac38b801b25/script.js";
        // script1.async = true;
    
        // document.body.appendChild(script1);
    }

    async getVisit() {
        const visitList = await webapi.get('pages/visit');
        this.setState({
            VisitData: visitList.data
        });
        //console.log(visitList.data);
    }

    render() {
        if (this.state.pageData) {
            return (
                <div className="absolute">
                    <div className="container-fluid" id="footer_container_fluid">
                        <div className="container">
                            <div id="footer_1">
                            <img alt="logo" src={ParsiglogoFooterpng}/>
                            <div id="columns">
                            <div className="column">
                                <a href="http://www.ihcs.ac.ir/fa" target="_blank" rel="noopener noreferrer"><img alt="01" src={Parsigpazhouheshgahpng} /></a>
                            </div>
                            <div className="column">
                                <a href="http://www.ashaerp.com" target="_blank" rel="noopener noreferrer"><img alt="01" src={Parsigashajpeg} /></a>
                            </div>
                            <div className="column">
                                <a href="http://www.ashaerp.com" target="_blank" rel="noopener noreferrer"><img alt="01" src={jpeg2} /></a>
                                </div>
                        </div>
                            </div>
                            {/* <div id="footer_2">
                            <h6>دسترسی سریع</h6>
                            <ul>
                                <li>
                                <a href="/aboutus">درباره پایگاه دادگان پارسیگ</a>
                                </li>
                                <li>
                                <a href="/help_search">راهنمای جستجو در پایگاه</a>
                                </li>
                                <li>
                                <a href="/help_tags">جدول برچسب های دستوری</a>
                                </li>
                                <li>
                                <a href="/library_res">منابع پایگاه</a>
                                </li>
                                <li>
                                <a href="/library_signs">علایم اختصاری کتاب ها</a>
                                </li>
                                <li>
                                <a href="/library_art">مقالات مرتبط</a>
                                </li>
                            </ul>
                            </div> */}
                            <div id="footer_3">
                            <h6>{this.state.pageData.length!==0 && this.state.pageData[0].F902!== undefined?this.state.pageData[0].F902:902/*پیوندها*/}</h6>
                            <ul>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="http://www.ihcs.ac.ir/">{this.state.pageData.length!==0 && this.state.pageData[0].F90201!== undefined?this.state.pageData[0].F90201:90201/*پژوهشگاه علوم انسانی و مطالعات فرهنگی*/}</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="http://pahlavazh.ihcs.ac.ir/">{this.state.pageData.length!==0 && this.state.pageData[0].F90202!== undefined?this.state.pageData[0].F90202:90202/*فرهنگ واژه‌های فارسی میانه-فارسی نو (پهلواژ)*/}</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="http://pldb.ihcs.ac.ir/">{this.state.pageData.length!==0 && this.state.pageData[0].F90203!== undefined?this.state.pageData[0].F90203:90203/*پایگاه دادگان زبان فارسی*/}</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="http://pahlavica.org/">{this.state.pageData.length!==0 && this.state.pageData[0].F90204!== undefined?this.state.pageData[0].F90204:90204/*دایره‌المعارف فارسی میانه (پهلویکا)*/}</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="http://titus.uni-frankfurt.de/">{this.state.pageData.length!==0 && this.state.pageData[0].F90205!== undefined?this.state.pageData[0].F90205:90205/*تزاروس زبان‎های هندواروپایی و مواد متنی (تیتوس)*/}</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="https://ada.geschkult.fu-berlin.de/">{this.state.pageData.length!==0 && this.state.pageData[0].F90206!== undefined?this.state.pageData[0].F90206:90206/*آرشیو دیجیتال متون اوستایی*/}</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="http://avestica.org/">{this.state.pageData.length!==0 && this.state.pageData[0].F90207!== undefined?this.state.pageData[0].F90207:90207/*دایره‌المعارف اوستا (اوستیکا)*/}</a>
                                </li>
                            </ul>
                            </div>
                            <div id="footer_4">
                            {
                                (this.state.VisitData)
                                ?
                                <div>
                                    <h6>
                                        {this.state.pageData.length!==0 && this.state.pageData[0].F901!== undefined?this.state.pageData[0].F901:901/*آمار سایت*/}
                                    </h6>
                                    <ul>
                                        <li>
                                            {this.state.pageData.length!==0 && this.state.pageData[0].F90101!== undefined?this.state.pageData[0].F90101:90101/*کاربران آنلاین*/}: {this.state.VisitData[0].OnLine}
                                        </li>
                                        <li>
                                            {this.state.pageData.length!==0 && this.state.pageData[0].F90102!== undefined?this.state.pageData[0].F90102:90102/*بازدیدهای امروز*/}: {this.state.VisitData[0].ThisDay}
                                        </li>
                                        <li>
                                            {this.state.pageData.length!==0 && this.state.pageData[0].F90103!== undefined?this.state.pageData[0].F90103:90103/*بازدیدهای ماه گذشته*/}: {this.state.VisitData[0].ThisMonth}
                                        </li>
                                        <li>
                                            {this.state.pageData.length!==0 && this.state.pageData[0].F90104!== undefined?this.state.pageData[0].F90104:90104/*تمام بازدیدها*/}: {this.state.VisitData[0].AllVisits}
                                        </li>
                                        <li>
                                            {this.state.pageData.length!==0 && this.state.pageData[0].F90105!== undefined?this.state.pageData[0].F90105:90105/*جستجوهای امروز*/}: {this.state.VisitData[0].ThisDaySearches}
                                        </li>
                                        <li>
                                            {this.state.pageData.length!==0 && this.state.pageData[0].F90106!== undefined?this.state.pageData[0].F90106:90106/*جستجوهای ماه گذشته*/}: {this.state.VisitData[0].ThisMonthSearches}
                                        </li>
                                        <li>
                                            {this.state.pageData.length!==0 && this.state.pageData[0].F90107!== undefined?this.state.pageData[0].F90107:90107/*تمام جستجوها*/}: {this.state.VisitData[0].AllSearches}
                                        </li>
                                    </ul>
                                </div>
                                :
                                null
                            }
                            </div>
                        </div>
                        </div>
                        <div className="container-fluid" id="footer_bottom">
                        <div className="container">
                            <p>{this.state.pageData.length!==0 && this.state.pageData[0].F90901!== undefined?this.state.pageData[0].F90901:90901/*استفاده از داده‌های این سایت با ذکر منبع بلامانع است.*/}</p>
                            <p className="left_align" style={{textAlign:"center"}}>{this.state.pageData.length!==0 && this.state.pageData[0].F90902!== undefined?this.state.pageData[0].F90902:90902/*©2020 Pārsīgdatabase. All Rights Reserved.*/}</p>
                            <img alt="up" src={Parsiguparrowpng} id="scroll_to_top" />
                            
                        </div>
                    </div>
                    
                </div>
            )
        }
        else
            return null;
    }
}

export default Footer;        